export enum EOnboardingPageType {
  Login = 'login',
  SignUp = 'sign_up',
  Verification = 'verification',
  LocationNotAllowed = 'location_not_allowed',
  ForgotPassword = 'forgot_password',
  DepositLimit = 'deposit_limit',
}
